import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Slider,
  Switch,
  Typography,
} from '@mui/material';
import { CardSize } from '../../hooks/useUiPreferences';

export function InventoryDensityControl({
  cardSize,
  onCardSizeChange,
  removeMargins,
  onRemoveMarginsChange,
}: {
  cardSize: CardSize;
  onCardSizeChange: (value: CardSize) => void;
  removeMargins: boolean;
  onRemoveMarginsChange: (value: boolean) => void;
}) {
  return (
    <FormControl fullWidth sx={{ gap: 0.5, px: 1, mb: 2 }}>
      <FormLabel>Display size</FormLabel>
      <Slider
        aria-label="Display size"
        value={cardSize}
        min={1}
        max={9}
        step={1}
        getAriaValueText={(value) => `Display size ${value} of 9`}
        onChange={(_, value) => onCardSizeChange(value as CardSize)}
        sx={{ mt: 1 }}
      />
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="caption" color="text.secondary">
          Compact
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Spacious
        </Typography>
      </Box>
      <FormControlLabel
        control={
          <Switch
            checked={removeMargins}
            onChange={(event) => onRemoveMarginsChange(event.target.checked)}
          />
        }
        label="Remove page margins"
        sx={{ mt: 1 }}
      />
    </FormControl>
  );
}
